var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
import React from 'react';
import { action, observable, when, makeObservable } from 'mobx';
import { observer } from 'mobx-react';
import { AvailableTooltip } from '../../../../components/other/AvailableTooltip';
let CloseAd = class CloseAd extends React.PureComponent {
    isHovering = false;
    constructor(props) {
        super(props);
        makeObservable(this);
    }
    get color() {
        if (this.isHovering)
            return 'rgba(0,0,0,0.8)';
        return 'rgba(0,0,0,0.3)';
    }
    render() {
        const { app } = this.props;
        return (React.createElement(AvailableTooltip, { title: "Erweitere auf Schlaukopf Premium, um werbefrei zu lernen.", placement: "right" },
            React.createElement("i", { className: "fas fa-times", onClick: async () => {
                    await when(() => !!app.menubar.menubarRight);
                    app.menubarRight.togglePremiumDialog();
                }, onMouseEnter: action(() => (this.isHovering = true)), onMouseLeave: action(() => (this.isHovering = false)), style: {
                    position: 'relative',
                    alignSelf: 'flex-start',
                    top: -18,
                    left: 8,
                    fontSize: 22,
                    cursor: 'pointer',
                    color: this.color,
                    float: 'right'
                } })));
    }
};
__decorate([
    observable
], CloseAd.prototype, "isHovering", void 0);
CloseAd = __decorate([
    observer
], CloseAd);
export { CloseAd };
